module.exports = __webpack_public_path__ + "static/infraspace_screen-67d4af75b652aef88630f445546a74cb.jpg";